
export default {
  updateProduct: {
    selectedParts: {},
    selectedAttr: {
      attrName: null,
      attrValue: null,
    },
    selectedContrasts: {},
    selectedFabric: { },
    selectedButtons: {}
  },
  updateSize: {
    userMaleSizes: {},
    sizeStandart: {},
    sizeSmart: {}
  },
  updatePrice: {
    shirtPrice: {
      price: 0,
      discount: 0,
    },
    contextPrice: {
      byFabric: 0,
      byDetail: 0,
      byContrast: 0,
      byDiscount: 0
    },
    byFabric: 0,
    byDetail: 0,
    byContrast: 0,
    byDiscount: 0,
    totalPrice: 0
  },
}
